<template>
  <table
    class="tw-w-full tw-rounded tw-text-left tw-text-base"
    :class="className"
    v-bind="$attrs"
  >
    <slot />
  </table>
</template>

<script setup lang="ts">
import { toRefs } from "vue";

const props = defineProps<{
  className?: Record<string, boolean> | string[] | string;
}>();

const { className } = toRefs(props);
</script>
